<script lang="ts" setup>
const localePath = useLocalePath()
const { locale, availableLocales } = useI18n()

const legalPaths = ['/legal/terms-of-service', '/legal/privacy-policy']

// FIXME: Only fetch for relevant locale, doesn't seem to be working due to a bug in nuxt content
// Need to figure it out or submit it together with a repoducable repo.
const { data: legalPagesByLocale } = await useAsyncData('legalPagesByLocale', async () =>
  Object.fromEntries(
    await Promise.all(
      availableLocales.map(async (locale) => [
        locale,
        await queryCollection('content')
          .select('path', 'title')
          .where(
            'path',
            'IN',
            legalPaths.map((path) => localePath(path, locale)),
          )
          .all(),
      ]),
    ),
  ),
)

const legalPages = computed(() => legalPagesByLocale.value[locale.value])
</script>

<template>
  <footer>
    <div class="inner">
      <div>
        <h4>{{ $t('footer.legal') }}</h4>
        <ul>
          <li v-for="page of legalPages" :key="page.path">
            <NuxtLink :to="page.path">{{ page.title }}</NuxtLink>
          </li>
        </ul>
      </div>
      <div>
        <h4>{{ $t('footer.address.title') }}</h4>
        <address>
          Stationsplein 45<br>
          {{ $t('footer.address.office') }} D3.112<br>
          3013 AK Rotterdam
        </address>
      </div>
      <div>
        <h4>{{ $t('footer.contact.title') }}</h4>
        <dl>
          <dt>{{ $t('footer.contact.support') }}</dt>
          <dd><a href="mailto:support@silvabird.com">support@silvabird.com</a></dd>
          <dt>{{ $t('footer.contact.abuse') }}</dt>
          <dd><a href="mailto:abuse@silvabird.com">abuse@silvabird.com</a></dd>
          <dt>{{ $t('footer.contact.postmaster') }}</dt>
          <dd><a href="mailto:postmaster@silvabird.com">postmaster@silvabird.com</a></dd>
        </dl>
      </div>
      <p class="non-tracking-notice">
        <i18n-t keypath="footer.nonCookieMessage.noBanner">
          <template v-slot:noTracking>
            <b>{{ $t('footer.nonCookieMessage.noTracking') }}</b>
          </template>
        </i18n-t>
      </p>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
footer {
  margin-top: 100px;
  box-shadow: inset 0px 65px 65px 18px #5a638112;
  border-top: 1px solid var(--border-subtle);

  .inner {
    max-width: 1200px;
    margin: auto;
    padding: 40px;
    gap: 10px 40px;
    min-height: 150px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
  }
}

ul {
  list-style-type: none;
  padding: 0;
}

address {
  font-style: normal;
}

dl {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;

  dt {
    color: var(--text-subtle);
    font-size: 0.8em;
  }

  dd {
    margin: 0 0 8px;
  }
}

.non-tracking-notice {
  width: 100%;
  text-align: center;
  color: var(--text-subtle);
  margin: 50px 0;
}
</style>
